import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SECTIONS = [
  {
    title: "Qu'est-ce qu'un cookie ?",
    content: `Un cookie est un petit fichier texte déposé sur votre appareil (ordinateur, tablette, smartphone) lors de la visite d'un site web. Il permet au site de mémoriser certaines informations relatives à votre navigation.

Les cookies ne contiennent pas de virus et ne peuvent pas endommager votre appareil.`,
  },
  {
    title: 'Les cookies que nous utilisons',
    content: `Notre site n'utilise que des cookies strictement nécessaires au bon fonctionnement du service. Nous n'utilisons aucun cookie publicitaire, de tracking, d'analyse comportementale ou de profilage.

Les cookies essentiels utilisés sont :

• Firebase Authentication — permet de gérer votre session de connexion et de sécuriser l'accès à votre espace personnel. Sans ce cookie, vous ne pouvez pas rester connecté entre deux pages.`,
  },
  {
    title: 'Ce que nous ne faisons pas',
    content: `Nous tenons à être transparents sur ce que notre site ne fait pas :

• Aucun cookie publicitaire (Google Ads, Facebook Pixel, etc.)
• Aucun outil de tracking ou d'analyse comportementale (Google Analytics, Hotjar, etc.)
• Aucune revente ou partage de vos données de navigation avec des tiers
• Aucun cookie de profilage ou de reciblage publicitaire`,
  },
  {
    title: 'Comment gérer vos cookies',
    content: `Vous pouvez à tout moment configurer votre navigateur pour accepter, refuser ou supprimer les cookies. Voici comment accéder aux paramètres des principaux navigateurs :

• Google Chrome : Paramètres > Confidentialité et sécurité > Cookies
• Safari : Préférences > Confidentialité
• Firefox : Paramètres > Vie privée et sécurité
• Edge : Paramètres > Confidentialité, recherche et services

Attention : le refus des cookies essentiels peut empêcher certaines fonctionnalités du site de fonctionner correctement (connexion).`,
  },
  {
    title: 'Contact',
    content: `Pour toute question relative à notre utilisation des cookies, vous pouvez nous contacter :

• Par email : contact@fouratacos.com
• Par courrier : Four a Tacos, 303 Rue de la République, 73000 Chambéry`,
  },
];

export default function PolitiqueCookies() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Politique de Cookies — Four A Tacos';
  }, []);

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main className="legal-main" style={{ flex: 1 }}>
        <h1 className="legal-title" style={{ marginBottom: '48px' }}>
          Politique de cookies
        </h1>

        {SECTIONS.map(({ title, content }) => (
          <section key={title} style={{ marginBottom: '40px' }}>
            <h2 style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#C10230', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
              {title}
            </h2>
            <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '15px', color: '#4A4A4A', lineHeight: '1.8', margin: 0, whiteSpace: 'pre-line' }}>
              {content}
            </p>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
